import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da2a72f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pulse-nav-container border-right pl-2 h-screen max-h-screen pulse-side-nav grid gap-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/PulseLogov2.png",
  alt: "Logo",
  class: "w-50 mt-3"
}, null, -1))
const _hoisted_3 = { class: "pr-2" }
const _hoisted_4 = {
  key: 0,
  class: "list-style-none overflow-auto mb-0"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "badge badge-primary p-1 align-self-center ml-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "list-style-none"
}
const _hoisted_8 = { class: "col-12 nav-item pl-0 py-2 d-flex align-items-center font-weight-bold" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" All Folders ")
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Administration", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sign Out", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'new-email' })), ["prevent"])),
        class: "cursor-pointer btn btn-primary btn-block text-white"
      }, " Compose ")
    ]),
    (!this.searchAllFolders)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (fld) => {
            return (_openBlock(), _createElementBlock("li", {
              key: fld.id,
              onClick: _withModifiers(($event: any) => (_ctx.goToFolder(fld)), ["prevent"]),
              class: _normalizeClass(["col-12 nav-item pl-0 py-2 d-flex align-items-center", _ctx.isSelected(fld) && 'font-weight-bold'])
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: _normalizeClass(["mr-3", _ctx.isSelected(fld) && 'text-primary']),
                icon: ['far', 'folder']
              }, null, 8, ["class"]),
              _createTextVNode(" " + _toDisplayString(fld.name) + " ", 1),
              (fld.unreadCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(fld.unreadCount), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (this.currentlySearching)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, {
              class: "mr-3 text-primary",
              icon: ['far', 'folder']
            }),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_10, [
      _createElementVNode("li", {
        class: _normalizeClass(["col-12 nav-item pl-0 py-2", _ctx.$route.path.startsWith('/settings') && 'font-weight-bold']),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'settings' })), ["prevent"]))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'cog'],
          class: _normalizeClass(_ctx.$route.path.startsWith('/settings') && 'text-primary')
        }, null, 8, ["class"]),
        _hoisted_11
      ], 2),
      _createElementVNode("li", {
        class: "col-12 nav-item pl-0 py-2",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sign-out-alt'] }),
        _hoisted_12
      ])
    ])
  ]))
}